module.exports = __webpack_public_path__ + "static/media/magdalena@3x.adb24ffc.jpg";